import React from 'react';
import "./Fireproof.css";

function Fireproof() {
  return (
    <div>
      
    </div>
  )
}

export default Fireproof
